// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bc4e9a278f7177a8915f","655":"ac9057705ef617c2b888"}[chunkId] + ".js";
};